/**
 * Created by anatolij on 29.09.2026
 */

Mission.TYPE_ROYAL_LEAGUE = 107;

Mission.REGISTRATIONS.set(Mission.TYPE_ROYAL_LEAGUE, () => ({
    available: cleverapps.config.availables.ROYAL_LEAGUE_MISSION,
    name: "RoyalLeague",
    logic: RoyalLeagueLogic,
    view: RoyalLeagueWindow,
    startWindow: RoyalLeagueStartWindow,
    guideWindow: RoyalLeagueRulesWindow,
    schedule: "2 weeks",
    manualStart: RoyalLeagueLogic.Starter,
    autoStart: false,
    prize: RewardsConfig.RoyalLeague,
    stages: RewardsConfig.RoyalLeagueStages,
    teaser: false,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    abTest: () => cleverapps.abExperiments.getGroup(ABExperiments.Tests.royalLeague) === "A",
    competition: {
        algo: PersonalBestBotAlgorithm,
        avgSpeed: "royal_league",
        amount: [20, 30],
        forceCoef: [90, 120],
        stepMultiple: 5,
        prizeIconsBundle: "royal_league_table"
    },
    sideBarJson: bundles.sidebar.jsons.royal_league_icon_json
}));

cleverapps.InitByFeature["royal_league"] = function () {
    cleverapps.tutorial.register(RoyalLeagueTutorial());
};
